// The events that the machine handles
export enum RedeemEvent {
  INPUT_CHANGE = 'INPUT_CHANGE',
  CHECK_INPUT = 'CHECK_INPUT',
  REDEEM = 'REDEEM',
  SELECT_TOKEN_TO_REDEEM = 'SELECT_TOKEN_TO_REDEEM',
  RESET_ONE_TOKEN_ALLOWANCE = 'RESET_ONE_TOKEN_ALLOWANCE',
  APPROVE_ONE_TOKEN_ALLOWANCE = 'APPROVE_ONE_TOKEN_ALLOWANCE',
  UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO',
}

